// Module B — High Risk Patient Surveillance (Surveillance Panel)
// Pacientes de alto riesgo sin care management, priorizados por score compuesto.

import HighRiskSurveillancePage from "./pages/HighRiskSurveillancePage";

// Export routes for AppRouter
export const highRiskSurveillanceRoutes = [
  {
    path: "/high-risk-surveillance",
    element: <HighRiskSurveillancePage />,
  },
];

// Export components for external use
export { default as HighRiskSurveillancePage } from "./pages/HighRiskSurveillancePage";
